import { firebaseConfig } from 'config';

import { createStore, compose } from 'redux';
import { reduxFirebase } from 'redux-firebasev3';

import { userPathForUid } from './utils/firebasePaths';
import rootReducer from './reducers';

export default function configureStore(initialState) {
  const createStoreWithMiddleware = compose(
    reduxFirebase(firebaseConfig, {
      userProfile: userPathForUid
    }),
    process.env.NODE_ENV === 'development' &&
    typeof window === 'object' &&
      typeof window.devToolsExtension !== 'undefined' ?
        window.devToolsExtension() : f => f
  )(createStore);
  const store = createStoreWithMiddleware(rootReducer, initialState);

  return store;
}



/** WEBPACK FOOTER **
 ** ./src/configureStore.js
 **/